import type {
  ExplicitFunnelSelection,
  FunnelPlanRow,
} from './contentFunnelSelection.types'

export function funnelPlanRowKey(
  row: Pick<
    FunnelPlanRow,
    'template_key' | 'category_id' | 'marketplace' | 'seller_id' | 'cabinet'
  >,
): string {
  return [
    row.template_key,
    Number(row.category_id),
    row.marketplace,
    Number(row.seller_id),
    String(row.cabinet || '').trim().toLowerCase(),
  ].join(':')
}

export function initialFunnelChoices(rows: FunnelPlanRow[]): Record<string, string> {
  return Object.fromEntries(
    rows.map((row) => {
      const automatic = row.automatic_selection
      return [
        funnelPlanRowKey(row),
        automatic ? `${automatic.version_id}:${automatic.rule_id}:auto` : '',
      ]
    }),
  )
}

export function serializeFunnelSelections(
  rows: FunnelPlanRow[],
  choices: Record<string, string>,
): ExplicitFunnelSelection[] {
  const selections: ExplicitFunnelSelection[] = []
  for (const row of rows) {
    const value = choices[funnelPlanRowKey(row)] || ''
    if (!value) continue
    const [versionValue, ruleValue, sourceValue] = value.split(':')
    const versionId = Number(versionValue)
    const ruleId = Number(ruleValue)
    const candidate = row.candidates.find(
      (item) => item.version_id === versionId && item.rule_id === ruleId,
    )
    if (!candidate) continue
    selections.push({
      template_key: row.template_key,
      category_id: row.category_id,
      category_prefix: row.category_prefix,
      marketplace: row.marketplace,
      seller_id: row.seller_id,
      cabinet: row.cabinet,
      version_id: versionId,
      rule_id: ruleId,
      source: sourceValue === 'auto' ? 'auto' : 'manual',
    })
  }
  return selections
}

